export const tagColors = ["red", "magenta", "purple", "blue", "cyan", "teal", "green"];

//用于template filter编辑器的名字field
export let homeFilterList = [
  {
    selectId: 0,
    type: "MultiSelect",
    label: "Intent",
    attrKey: "intent",
    mapKey: "intent",
    invalid: false,
    isValid: false,
    optionItemType: "object",
    initselectItems: [],
    // randomKey: "0",
    options: [],
  },
  {
    selectId: 1,
    isValid: false,
    type: "Select",
    label: "Auto reply",
    attrKey: "auto_reply",
    invalid: false,
    selectValue: "",
    optionItemType: "object",
    width: "200px", //选择框的长度
    // optionItemType: "object", //用于判断option item的类型 方便对选项进行选中
    options: [{ value: 1, label: "Yes" }, { value: 0, label: "No" }],
  },
];

